// API error classes (FormSubmissionError, UnauthenticatedError, ServerError,
// PageNotFoundError, BadRequestError) now live in `@codametrix/client-api`,
// which is the single canonical owner of the browser HTTP API boundary. Import
// them from there. Only non-API error utilities remain here.

const getFieldErrorMessage = (
  formErrors: CMxCommonApp.FormErrors,
  keys: string[]
) => {
  const { fieldErrors } = formErrors;
  let fieldErrorMessage = '';

  for (const fieldErrorKey in fieldErrors) {
    if (keys.some(key => key === fieldErrorKey)) {
      fieldErrorMessage =
        fieldErrorMessage + fieldErrors[fieldErrorKey].join('. ');
    }
  }
  return fieldErrorMessage;
};

export { getFieldErrorMessage };
